import React, { useEffect, useState } from "react";
import { Input, Row, Col } from "antd";
import { success, error } from "../contants/snackbars";
import {
  LoadingButton,
  PrimaryButton,
} from "../custom_components/customButton";
import { editWhatsAppNumber, fetchWhatsAppNumber } from "../stores/api_calls/about";
import { colorScheme } from "../contants/variables";

const WhatsAppNumber= () => {
  const [form, setForm] = useState({
    title: "",
    description: "WhatsApp Number",
    id: "63e2e500414600005e0042b3",
  });
  const [requestLoading, setRequestLoading] = useState(false);

  useEffect(() => {
    getContent();
  }, []);

  const getContent = () => {
    const updateContent = fetchWhatsAppNumber({ id: "63e2e500414600005e0042b3" });
    updateContent
      .then((res) => {
        if (res.data.success) {
          setForm({ ...form, title: res.data.data.title });
        }
      })
      .catch((e) => {
        error("Failed to retrieve content");
      });
  };


  const handleFieldChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.value,
    });
  };

  const onSubmit = () => {
    setRequestLoading(true);

    const transformedData = form;

    const updateContent = editWhatsAppNumber(transformedData);
    updateContent
      .then((res) => {
        if (res.data.success) {
          success("Successfully updated");
          setRequestLoading(false);
        }
      })
      .catch((e) => {
        error("Failed to save changes");
        setRequestLoading(false);
      });
  };

  return (
    <div>
      <h1>WhatsApp Number</h1>
      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              WhatsApp Number <span>*</span> :{" "}
            </p>
            <Input
              value={form.title}
              onChange={(text) => handleFieldChange("title", text)}
            />
          </div>
        </Col>
        
        <Col span={24}></Col>

        <div className="btn-div" style={{ marginTop: 24 }}>
          <div className="btn">
            {requestLoading ? (
              <LoadingButton />
            ) : (
              <PrimaryButton
                label="Save Changes"
                color={colorScheme.primary}
                onClick={() => onSubmit()}
                disabled={!form.title}
              />
            )}
          </div>
        </div>

      </Row>
    </div>
  );
};

export default WhatsAppNumber;
